<template>
  <div>
    <loading :message='"ログアウト中です"'></loading>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import Config from '@/const/Config'

export default defineComponent({
  setup() {

    onMounted(async () => {
      const sendMessage = new Promise((resolve, reject) => {
        try {
          window.Logout.postMessage('')
        } catch (error) {
          // ブラウザだと失敗するので握りつぶす
        } finally {
          resolve('')
        }
      })

      await sendMessage.then(() => {
        location.href = Config.DESTROY_URL
      })
    })
  },
})
</script>